import { useRef } from 'react';

export function useInitialSearchParams(): URLSearchParams {
  const ref = useRef<URLSearchParams | null>(null);
  if (ref.current === null) {
    ref.current = new URLSearchParams(window.location.search);
  }
  return ref.current;
}
